import React, { FC, useCallback } from "react";
import { motion } from "framer-motion";
import styled from "@emotion/styled";
import { withIsVisible } from "../../utils/reactUtils";

export interface QuoteBarProps {
  progress: number;
}

const QuoteBar: FC<QuoteBarProps> = ({ progress }) => {
  const clampNumber = useCallback(
    (num: number, min: number, max: number) =>
      Math.max(Math.min(num, Math.max(min, max)), Math.min(min, max)),
    []
  );
  const clampedProgress = clampNumber(progress, 0, 100);

  return (
    <ProgressContainer>
      <StyledQuoteBar
        initial={{ width: "100%" }}
        animate={{ width: `${100 - clampedProgress}%` }}
        role="progressbar"
        progress={progress}
      />
    </ProgressContainer>
  );
};

export default withIsVisible(QuoteBar);

const StyledQuoteBar = styled(motion.div)<{ progress: number }>`
  background-color: #c6d0d0;
  border-radius: 3px;
  transition: ${props => (props.progress === 0 ? "none" : "width 1s linear !important")};
`;

const ProgressContainer = styled.div`
  height: 6px;
  background-color: #607b7a;
  border-radius: 3px;
  display: flex;
`;
